import { render, staticRenderFns } from "./WechatBind.vue?vue&type=template&id=0de6d3fa&scoped=true"
import script from "./WechatBind.vue?vue&type=script&lang=js"
export * from "./WechatBind.vue?vue&type=script&lang=js"
import style0 from "./WechatBind.vue?vue&type=style&index=0&id=0de6d3fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de6d3fa",
  null
  
)

export default component.exports